module.exports = __webpack_public_path__ + "static/media/biglogo.a619058c.png";